import { cloneFast } from "../lang";
export function getDebugParams(cgiInfo, key) {
  const {
    debugParamsArray = [],
    multipleDebugParams
  } = cgiInfo;
  // @ts-ignore
  const defaultParams = cgiInfo[key];
  if (!defaultParams) {
    return null;
  }
  if (!multipleDebugParams) {
    return defaultParams;
  }
  const target = debugParamsArray.find(p => p.use);
  if (!target) {
    return defaultParams;
  }
  return target.params;
}
export function cloneCgiInfoWithDebugParams(cgiInfo) {
  const newCgiInfo = cloneFast(cgiInfo);
  const debugParamsKey = ['debugParam', 'debugParams'].find(key => newCgiInfo[key]);
  if (!debugParamsKey) {
    return newCgiInfo;
  }
  newCgiInfo[debugParamsKey] = getDebugParams(newCgiInfo, debugParamsKey);
  return newCgiInfo;
}
//# sourceMappingURL=debugParams.js.map
